import { render, staticRenderFns } from "./UsabilidadeDoSistemaProfessorPage.vue?vue&type=template&id=4c0acae0&scoped=true"
import script from "./UsabilidadeDoSistemaProfessorPage.vue?vue&type=script&lang=js"
export * from "./UsabilidadeDoSistemaProfessorPage.vue?vue&type=script&lang=js"
import style0 from "./UsabilidadeDoSistemaProfessorPage.vue?vue&type=style&index=0&id=4c0acae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0acae0",
  null
  
)

export default component.exports